export const storageKey = {
  AUTH_STORE: 'GLOW_AUTH_STORE_V1',
  PREFERENCE_STORE: 'GLOW_PREFERENCE_STORE_V1',
  GUEST_STORE: 'GLOW_GUEST_STORE_V1',
} as const;

export type StorageKey = (typeof storageKey)[keyof typeof storageKey];
